module.exports = __webpack_public_path__ + "img/GPB_top10-2.fd8fa821.png";